module.exports = __webpack_public_path__ + "components/country-flag/static/ua-b67225e1ac14a8a5a2e36293e725a6fd.svg";